import common from './common'
import url from './url'
import logger from './logger'
import userAgent from './userAgent'

export default {
  common,
  url,
  logger,
  userAgent
}



// WEBPACK FOOTER //
// ./src/library/core/index.js